import { forwardRef, InjectionToken, Type } from '@angular/core';
import { FilterBean } from '@type/filter.type';
import { BaseFilterItem } from '../directives/base-filter-item.directive';

export const FILTER_ITEM = new InjectionToken<BaseFilterItem<{} extends FilterBean ? FilterBean : never>>(
  'FILTER_ITEM',
);

export function provideFilterItem<T>(fn: Type<T>) {
  return { provide: FILTER_ITEM, useExisting: forwardRef(() => fn) };
}
